import { Pagination } from '@mantine/core';
import { ChevronLeftIcon, ChevronRightIcon } from '@zenos/front-end-ui-icons';
import classNames from './Pagination.module.css';

// eslint-disable-next-line react-refresh/only-export-components
export default Pagination.extend({
  classNames,
  defaultProps: {
    nextIcon: ChevronRightIcon,
    previousIcon: ChevronLeftIcon,
  },
});
